import { useState } from "react";

import { ENDPOINTS, useApi } from "../../../../../shared";
import { TokenData, TransferDevicesValidationProps } from "../types";

const useTokenValidation = ({
    token,
    removeResize
}: TransferDevicesValidationProps) => {
    const { getData } = useApi();

    const [tokenError, setTokenError] = useState("");
    const [isTokenLoading, setIsTokenLoading] = useState(false);

    const [validationData, setValidationData] = useState<TokenData | null>(
        null
    );

    const clearTokenError = () => setTokenError("");

    const validateToken = async () => {
        if (token) {
            try {
                setIsTokenLoading(true);

                const { data } = await getData(`${ENDPOINTS.Tokens}/${token}`);

                setTokenError("");
                setValidationData(data);
                removeResize(false);
            } catch (error) {
                const errorMessage =
                    (error as any)?.response?.data?.message || "";

                setTokenError(errorMessage);
                setValidationData(null);
            }
        }

        setIsTokenLoading(false);
    };

    const clearValidationData = () => {
        setValidationData(null);
        removeResize(true);
    };

    return {
        tokenError,
        isTokenLoading,
        validationData,
        validateToken,
        clearTokenError,
        clearValidationData
    };
};

export { useTokenValidation };
